var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.73 141.73",
    enableBackground: "new 0 0 141.73 141.73",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -163.0435,
    y1: 70.865,
    x2: -66.3884,
    y2: 70.865,
    gradientTransform: "matrix(-1 0 0 1 -51.7821 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#47B4E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1718,
    style: {
      stopColor: "#1588E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6EB4E0"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M74.172,22.025l19.459,19.459c1.827,1.827,1.827,4.788,0,6.614l0,0 c-1.827,1.827-4.788,1.827-6.614,0L74.172,35.254c-1.827-1.827-4.788-1.827-6.614,0L35.254,67.558 c-1.827,1.827-1.827,4.788,0,6.614l32.304,32.304c1.827,1.827,4.788,1.827,6.614,0l12.845-12.845c1.827-1.827,4.788-1.827,6.614,0 l0,0c1.827,1.827,1.827,4.788,0,6.614l-19.459,19.459c-1.827,1.827-4.788,1.827-6.614,0L22.025,74.172 c-1.827-1.827-1.827-4.788,0-6.614l45.532-45.532C69.384,20.199,72.346,20.199,74.172,22.025z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 272.7237,
    y1: -373.9296,
    x2: 307.767,
    y2: -373.9296,
    gradientTransform: "matrix(8.979300e-11 -1 -1 -8.979300e-11 -263.9545 361.1103)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0322,
    style: {
      stopColor: "#F0776F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5032,
    style: {
      stopColor: "#F0656F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0606F"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M100.246,54.713L100.246,54.713c1.827-1.827,4.788-1.827,6.614,0l12.845,12.845 c1.827,1.827,1.827,4.788,0,6.614L106.86,87.017c-1.827,1.827-4.788,1.827-6.614,0h0c-1.827-1.827-1.827-4.788,0-6.614l6.23-6.23 c1.827-1.827,1.827-4.788,0-6.614l-6.23-6.23C98.419,59.501,98.419,56.54,100.246,54.713z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.2245,
    y1: 483.7575,
    x2: 297.8502,
    y2: 483.7575,
    gradientTransform: "matrix(-8.979300e-11 1 1 8.979300e-11 -412.8925 -212.1723)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0322,
    style: {
      stopColor: "#F0776F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5032,
    style: {
      stopColor: "#F0656F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F0606F"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M70.865,85.678c8.181,0,14.813-6.632,14.813-14.813c0-8.181-6.632-14.813-14.813-14.813 c-8.181,0-14.813,6.632-14.813,14.813C56.052,79.046,62.684,85.678,70.865,85.678z M70.865,78.564c-4.252,0-7.699-3.447-7.699-7.699 c0-4.252,3.447-7.699,7.699-7.699s7.699,3.447,7.699,7.699C78.564,75.117,75.117,78.564,70.865,78.564z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg);
export default __webpack_public_path__ + "static/media/img.c7499608444192ed8309d76468f59bf3.svg";
export { ForwardRef as ReactComponent };